@if (form) {
<form class="dialog-form position-relative">
  <!-- Loading Overlay -->
  <!-- <app-overlay-loading-spinner *ngIf="isLoadingAddEditItem"></app-overlay-loading-spinner> -->

  @if (form.length) {
  <div class="row">
    <app-form [formConfig]="form" [validationEmit]="validationEmit" [hasButton]="false"
      (onFilterSelectField)="onFilterSelect($event)" (onChange)="valueChanged($event)"
      [validationErrors]="validationErrors" (onSubmit)="submitForm($event)">
    </app-form>

    @if (!dataObj.data.visible && accountUserId) {
    <div class="item-details mt-2">
      <!-- Specialized Roles Section -->
      <label *ngIf="formValues?.specializedRoles?.length > 0" class="form-label">{{"USER_MANAGEMENT.SPECIALIZED_ROLES" | translate}}</label>
      <span *ngIf="formValues?.specializedRoles?.length > 0" class="d-flex gap-1 align-items-center flex-wrap">
        @for (item of formValues?.specializedRoles; track $index) {
        <span class="tags-badge-item">
          {{ item?.englishName }}
        </span>
        }
      </span>

      <!-- System Roles Section -->
      <div *ngIf="formValues?.systemRoles?.length > 0" class="item-details mt-2">
        <label class="form-label">{{"USER_MANAGEMENT.SYSTEM_ROLES" | translate}}</label>
        <span class="d-flex gap-1 align-items-center flex-wrap">
          @for (item of formValues?.systemRoles; track $index) {
          <span class="tags-badge-item">
            {{ item?.englishName }}
          </span>
          }
        </span>
      </div>
    </div>
    }
  </div>
  }

  <!-- Footer Buttons -->
  @if (dataObj.data?.visible) {
  <div class="dialog-footer d-flex justify-content-between">
    <button type="button" [disabled]="isLoadingAddEditItem" class="btn btn-outline-main" (click)="onClose()">
      {{"GENERAL.CANCEL" | translate}}
    </button>
    <button type="button" [disabled]="isLoadingAddEditItem" class="btn btn-solid-main" (click)="emitValidation()">
      @if (isLoadingAddEditItem) {
      <span class="spinner-border spinner-border-sm mr-1"></span>
      }
      {{ accountUserId ? ('GENERAL.UPDATE' | translate) : ('GENERAL.CREATE' | translate) }}
    </button>
  </div>
  }
</form>
}
